import React, { useEffect, useState } from 'react';
import { View, TextInput, StyleSheet, Text, BackHandler } from 'react-native';
import { FONT_STYLE } from '../../dataSchema/const';

const InputText = ({ handleText, defaultAnswer = null }) => {
  const [text, setText] = useState('');
  const [wordCount, setWordCount] = useState(0);
  const [isFocus, setFocus] = useState(false);

  const onChangeText = (text: string) => {
    setText(text);
  }

  const onHandleInputText = () => {
    if (handleText) {
      handleText(text);
    }
  }


  const onClearText = () => {
    setText('');
  };

  const onFocusInput = (wordCount) => {
    setWordCount(wordCount);
  }

  useEffect(() => {
    if (defaultAnswer && defaultAnswer.values) {
      onChangeText(defaultAnswer.values[0])
    }
  }, [])

  return (
    <View style={styles.inputWrapper}>
      <TextInput style={isFocus ? styles.focusTextField : styles.textField}
        value={text}
        onChangeText={(text) => {
          onChangeText(text)
          onFocusInput(text.length);
        }}
        onFocus={() => { setFocus(true) }}
        onBlur={() => {
          onHandleInputText();
          setFocus(false);
        }}
        autoFocus={false}
        placeholder='Nhập nội dung tại đây'
        placeholderTextColor={'#666666'}
        maxLength={255}
      />
      {
        isFocus ?
          (
            <Text style={styles.count}>{`Ký tự: ${wordCount}/255`}</Text>
          )
          : null
      }
    </View>
  );
};


const styles = StyleSheet.create({
  inputWrapper: {
    backgroundColor: '#FFFFFF',
    height: 100,
    alignContent: 'center',
    justifyContent: 'center'
  },
  textField: {
    padding: 10,
    marginTop: 5,
    height: 60,
    borderRadius: 10,
    borderColor: '#444444',
    borderWidth: 1,
    textAlignVertical: 'center',
    fontFamily: FONT_STYLE.MEDIUM,
    fontSize: 14
  },
  focusTextField: {
    padding: 10,
    marginTop: 5,
    height: 100,
    borderRadius: 10,
    borderColor: '#444444',
    borderWidth: 1,
    textAlignVertical: 'center',
    fontFamily: FONT_STYLE.MEDIUM,
    fontSize: 14
  },
  count: {
    position: 'absolute',
    textAlign: 'right',
    paddingRight: 10,
    fontSize: 14,
    color: '#444444',
    fontFamily: FONT_STYLE.MEDIUM,
    width: '100%',
    paddingTop: 70,
  },
  errorText: {
    padding: 5,
    fontSize: 14,
    fontFamily: FONT_STYLE.MEDIUM,
    color: 'red'
  }

})
export default InputText;
